<div class="container-history">
  <h2 class="title">History Book</h2>

  <div class="top-bar">
    <button [matMenuTriggerFor]="sortMenu" mat-fab color="primary">
      <mat-icon>filter_list</mat-icon>
    </button>

    <mat-form-field appearance="outline" style="width: 100%">
      <mat-label>Search</mat-label>
      <input matInput [(ngModel)]="searchTerm" />
      <mat-icon matSuffix>search</mat-icon>
    </mat-form-field>

    <mat-menu #sortMenu="matMenu">
      <button mat-menu-item (click)="setSortOrder('desc')">
        <mat-icon *ngIf="sortOrder === 'desc'">check</mat-icon>
        Oldest First
      </button>
      <button mat-menu-item (click)="setSortOrder('asc')">
        <mat-icon *ngIf="sortOrder === 'asc'">check</mat-icon>
        Newest First
      </button>
    </mat-menu>
  </div>

  <div class="history-table">
    <div class="table-container">
      <table>
        <thead>
          <tr>
            <th>Date</th>
            <th>Action</th>
            <th>Concept Title</th>
            <th>Key Words and Concepts</th>
            <th>New Names</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let action of filteredActions">
            <td>{{ action.date }} {{ action.time }}</td>
            <td>
              {{ action.action }}
            </td>
            <td *ngFor="let item of contentParsed(action.content)" [ngClass]="{ 'ql-editor card-list': item.key === 'Key Words and Concepts' }">
              <div [innerHTML]="item.value"></div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <div class="bottom-bar">
    <button
      mat-raised-button
      color="primary"
      (click)="downloadHistory()"
      class="w-full"
      [disabled]="!hasHistory"
    >
      <mat-icon>download</mat-icon>
      Download History
    </button>

    <button
      mat-raised-button
      color="warn"
      (click)="clearHistory()"
      class="w-full"
      [disabled]="!hasHistory"
    >
      <mat-icon>delete</mat-icon>
      Clear History
    </button>

    <button mat-button mat-dialog-close (click)="closeHistory()" class="w-full">
      Close
    </button>
  </div>
</div>
